import { mutator } from 'satcheljs';
import { onMenuCollapsedChanged } from '../actions';
import { getAppStore } from '../store/store';

mutator(onMenuCollapsedChanged, msg => {
  getAppStore().menuCollapsed = msg.collapsed;
});
